import { toast } from 'react-toastify';

export default function useToast() {

    function showErrorMessage(text: string) {
        toast.error(text, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });
    }

    function showSuccessMessage(text: string) {
        toast.success(text, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
        });
    }

    function showInfoMessage(text: string) {
        toast.info(text, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    }

    return { showErrorMessage, showSuccessMessage, showInfoMessage };
}
